import { fetch } from '../utils';

export const createConfigurationRepository = () => {
    const getPlacerBookies = () => fetch({
        method: 'get',
        path: 'configurations/placer/bookies',
        headers: {
            Authorization: localStorage.jwt,
        },
    });

    const updatePlacerBookies = (data) => fetch({
        method: 'put',
        path: 'configurations/placer/bookies',
        headers: {
            Authorization: localStorage.jwt,
        },
        data
    });

    const updatePlacerBookie = (bookie, data) => fetch({
        method: 'put',
        path: `configurations/placer/bookies/${bookie}`,
        headers: {
            Authorization: localStorage.jwt,
        },
        data
    });

    const getAnalyzedEvents = () => fetch({
        method: 'get',
        path: 'configurations/placer/surebets/analyzed-events',
        headers: {
            Authorization: localStorage.jwt,
        },
    });

    const addAnalyzedEvent = (eventId) => fetch({
        method: 'post',
        path: 'configurations/placer/surebets/analyzed-events',
        headers: {
            Authorization: localStorage.jwt,
        },
        data: { eventId }
    });

    const removeAnalyzedEvent = (eventId) => fetch({
        method: 'delete',
        path: `configurations/placer/surebets/analyzed-events/${eventId}`,
        headers: {
            Authorization: localStorage.jwt,
        },
    });

    const getClaimableBetIds = () => fetch({
        method: 'get',
        path: 'configurations/placer/surebets/claimable-bet-ids',
        headers: {
            Authorization: localStorage.jwt,
        },
    });

    const addClaimableBetId = (betId) => fetch({
        method: 'post',
        path: 'configurations/placer/surebets/claimable-bet-ids',
        headers: {
            Authorization: localStorage.jwt,
        },
        data: { betId }
    });

    const removeClaimableBetId = (betId) => fetch({
        method: 'delete',
        path: `configurations/placer/surebets/claimable-bet-ids/${betId}`,
        headers: {
            Authorization: localStorage.jwt,
        },
    });

    const getProxies = () => fetch({
        method: 'get',
        path: 'proxies/internal',
        headers: {
            Authorization: localStorage.jwt,
        },
    });

    return {
        getPlacerBookies,
        updatePlacerBookies,
        updatePlacerBookie,
        getAnalyzedEvents,
        addAnalyzedEvent,
        removeAnalyzedEvent,
        getClaimableBetIds,
        addClaimableBetId,
        removeClaimableBetId,
        getProxies
    };
}; 